<nz-alert *ngIf="value" nzType="warning" [nzMessage]="value" nzShowIcon></nz-alert>